export default __webpack_public_path__ + "static/media/NicolasQuintanaResume.f0310efa.pdf";